<!-- src/components/CreateGroupModal.vue -->
<template>
  <div class="modal-overlay" @click.self="cancel">
    <div class="modal-content">
      <h2>{{ $t('modals.createGroup.title') }}</h2>
      <p>{{ $t('modals.createGroup.description') }}</p>

      <input
        v-model="groupName"
        type="text"
        class="form-control rename-input-modal"
        :placeholder="$t('modals.createGroup.namePlaceholder')"
        maxlength="75"
        ref="groupNameInput"
        @keydown.enter="confirm"
      >
      <small class="char-counter">{{ groupName.length }} / 75</small>

      <div class="modal-actions">
        <button class="btn btn-secondary" @click="cancel">{{ $t('common.cancel') }}</button>
        <button class="btn tech-purple" @click="confirm" :disabled="!groupName.trim()">{{ $t('common.create') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CreateGroupModal',
  data() {
    return {
      groupName: ''
    };
  },
  mounted() {
    // Automatically focus the input when the modal appears
    this.$nextTick(() => {
      this.$refs.groupNameInput.focus();
    });
  },
  methods: {
    confirm() {
      if (this.groupName.trim()) {
        this.$emit('confirm', this.groupName.trim());
      }
    },
    cancel() {
      this.$emit('cancel');
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 30px 40px;
  border-radius: 12px;
  text-align: center;
  width: 90%;
  max-width: 450px;
}

.modal-content h2 {
  margin-bottom: 15px;
}

.modal-content p {
  margin-bottom: 20px;
  font-size: 1rem;
  color: #555;
}

.rename-input-modal {
  width: 100%;
  margin-bottom: 5px;
}

.char-counter {
  display: block;
  text-align: right;
  font-size: 0.8rem;
  color: #888;
  margin-bottom: 20px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.tech-purple {
  background-color: #6c63ff;
  color: white;
}
.tech-purple:hover{
  background-color: #5a54d1;
}
</style>
